import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=08389774&scoped=true"
import script from "./RequestDetails.vue?vue&type=script&lang=js"
export * from "./RequestDetails.vue?vue&type=script&lang=js"
import style0 from "./RequestDetails.vue?vue&type=style&index=0&id=08389774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08389774",
  null
  
)

export default component.exports